import { matchPath } from 'react-router';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';

import Paths from 'AppPaths';

export function getPathname(getState) {
  const { router } = getState();

  if (!router) return '';

  return router.location.pathname;
}

export function getEventRouteMatch(getState) {
  const pathName = getPathname(getState);

  let match = matchPath(pathName, {
    path: Paths.EventPage
  });

  return match;
}

export function getBroadcastRouteMatch(getState) {
  const pathName = getPathname(getState);

  let match = matchPath(pathName, {
    path: Paths.BroadcastPage
  });

  return match;
}

export const hasEventRouteState = getState => {
  const match = getEventRouteMatch(getState);

  return match ? true : false;
};

export const getCurrentTeamId = getState => {
  const teamRouteMatch = getEventRouteMatch(getState);
  if (!teamRouteMatch) return null;
  return teamRouteMatch.params.teamId;
};

export const getCurrentUserId = getState => {
  const { user } = getState();
  return user._id;
};

export const isAdminForTeam = getState => {
  const { user } = getState();
  const teamId = getCurrentTeamId(getState);
  return RoleHelper.hasTeamAdminRole(user, teamId);
};

/**
 * Helper for executing with current params..
 *
 * @param {*} cb
 */
export const withCurrentParams = cb => {
  return (dispatch, getState, socket) => {
    const match =
      getBroadcastRouteMatch(getState) || getEventRouteMatch(getState);

    if (match) {
      cb(dispatch, match.params, getState, socket);
    } else {
      throw new Error(
        'The current route does not have the necessary parameters'
      );
    }
  };
};

export const isSafariBrowser = () => {
  return (
    navigator.userAgent.includes('Safari') &&
    !(
      navigator.userAgent.includes('Chrome') ||
      navigator.userAgent.includes('Chromium')
    )
  );
};
